import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HitOverview } from '@compumark/order-management-client';

import { UiHitOverview } from '../adjust-hit-overview/adjust-hit-overview.component';
import { columnFields } from '../adjust-hit-overview/all-watch-results-columns';
import { AlertGridOptionsService } from '../alert-columns/alert-column-definition/alert-grid-options.service';
import { AlertApiClientService } from '../services/alert-api-client.service';

@Component({
  selector: 'app-adjust-existing-hit-overview',
  templateUrl: './adjust-existing-hit-overview.component.html',
  styleUrls: ['./adjust-existing-hit-overview.component.scss'],
  standalone: false,
})
export class AdjustExistingHitOverviewComponent implements OnInit {
  data = inject(MAT_DIALOG_DATA);
  private alertApiClientService = inject(AlertApiClientService);
  private alertGridOptionsService = inject(AlertGridOptionsService);
  dialogRef =
    inject<MatDialogRef<AdjustExistingHitOverviewComponent>>(MatDialogRef);

  columns: UiHitOverview[] = [];

  constructor() {
    const data = this.data;

    if (!data.hitOverView) {
      data.hitOverView = { enabled: true } as HitOverview;
    }
  }

  ngOnInit(): void {
    this.initializeColumns();
  }

  private initializeColumns(): void {
    const allowedFieldNames = new Set(
      columnFields.map((field) => field.fieldName),
    );

    const selectedFields = (this.data.hitOverView?.selectedFields || []).filter(
      (field: UiHitOverview) => allowedFieldNames.has(field.fieldName),
    );
    const selectedMapped: UiHitOverview[] = selectedFields.map(
      (sf: UiHitOverview) => ({
        fieldLabel: sf.fieldLabel!,
        fieldName: sf.fieldName!,
        fieldOrder: sf.fieldOrder,
        checked: true,
      }),
    );
    const unselectedMapped: UiHitOverview[] = columnFields
      .filter(
        (cf) =>
          !selectedFields.some(
            (sf: UiHitOverview) => sf.fieldName === cf.fieldName,
          ),
      )
      .map((cf) => ({
        ...cf,
        checked: false,
        fieldOrder: 999,
      }));
    this.columns = [...selectedMapped, ...unselectedMapped].sort(
      (a, b) => (a.fieldOrder ?? 999) - (b.fieldOrder ?? 999),
    );
  }

  buildSelectedColumns(): any {
    return this.columns
      .filter((col) => col.checked)
      .sort((a, b) => (a.fieldOrder ?? 0) - (b.fieldOrder ?? 0))
      .map((col, index) => ({
        fieldLabel: col.fieldLabel!,
        fieldName: col.fieldName!,
        fieldOrder: index + 1,
      }));
  }
  saveHitOverView(): void {
    const selectedColumns = this.buildSelectedColumns();
    this.data.id = this.data.originalId;
    this.data.hitOverView = {
      enabled: true,
      selectedFields: selectedColumns,
    };
    this.alertApiClientService.updateAlert(this.data).subscribe({
      next: () => {
        this.dialogRef.close();
        this.alertGridOptionsService.refreshGrid();
      },
    });
  }
}
